import { render, staticRenderFns } from "./provincial.vue?vue&type=template&id=72c9a78f&scoped=true"
import script from "./provincial.vue?vue&type=script&lang=js"
export * from "./provincial.vue?vue&type=script&lang=js"
import style0 from "./provincial.vue?vue&type=style&index=0&id=72c9a78f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9a78f",
  null
  
)

export default component.exports